import { render, staticRenderFns } from "./RelatedSearchQuery.vue?vue&type=template&id=6d87544c&scoped=true"
import script from "./RelatedSearchQuery.vue?vue&type=script&lang=js"
export * from "./RelatedSearchQuery.vue?vue&type=script&lang=js"
import style0 from "./RelatedSearchQuery.vue?vue&type=style&index=0&id=6d87544c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d87544c",
  null
  
)

export default component.exports